import '../utils/index.mjs';
import { eventReg, convertEventToLowerCase } from '../utils/util.mjs';
import { bindInstanceEvent } from '../utils/eventHelper.mjs';

function useEditor(editor, attrs) {
  if (!editor)
    return;
  const filters = ["addnode", "adjust", "removenode", "end", "move", "add"];
  const filterSet = {};
  Object.keys(attrs).forEach((key) => {
    if (eventReg.test(key)) {
      const eventKey = convertEventToLowerCase(key);
      if (filters.indexOf(eventKey) !== -1)
        filterSet[eventKey] = attrs[key];
    }
  });
  Object.keys(filterSet).forEach((key) => {
    bindInstanceEvent(editor, key, filterSet[key]);
  });
}

export { useEditor };
//# sourceMappingURL=useEditor.mjs.map
